/* tslint:disable */
/* eslint-disable */
/**
 * Core Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';

/**
 * 
 * @export
 * @interface SolrDocument
 */
export interface SolrDocument  {
    [key: string]: any | any;
    /**
     * 
     * @type {boolean}
     * @memberof SolrDocument
     */
    empty?: boolean;
    /**
     * 
     * @type {number}
     * @memberof SolrDocument
     * @deprecated
     */
    childDocumentCount?: number;
    /**
     * 
     * @type {{ [key: string]: Array<any>; }}
     * @memberof SolrDocument
     */
    fieldValuesMap?: { [key: string]: Array<any>; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof SolrDocument
     */
    fieldValueMap?: { [key: string]: any; };
    /**
     * 
     * @type {Array<string>}
     * @memberof SolrDocument
     */
    fieldNames?: Array<string>;
}

/**
 * Check if a given object implements the SolrDocument interface.
 */
export function instanceOfSolrDocument(value: object): value is SolrDocument {
    return true;
}

export function SolrDocumentFromJSON(json: any): SolrDocument {
    return SolrDocumentFromJSONTyped(json, false);
}

export function SolrDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): SolrDocument {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
                  'empty': json['empty'] == null ? undefined : json['empty'],
                  'childDocumentCount': json['childDocumentCount'] == null ? undefined : json['childDocumentCount'],
                  'fieldValuesMap': json['fieldValuesMap'] == null ? undefined : json['fieldValuesMap'],
                  'fieldValueMap': json['fieldValueMap'] == null ? undefined : json['fieldValueMap'],
              'fieldNames': json['fieldNames'] == null ? undefined : json['fieldNames'],
    };
}

export function SolrDocumentToJSON(json: any): SolrDocument {
    return SolrDocumentToJSONTyped(json, false);
}

export function SolrDocumentToJSONTyped(value?: SolrDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }
    return {
        
            ...value,
        'empty': value['empty'],
        'childDocumentCount': value['childDocumentCount'],
        'fieldValuesMap': value['fieldValuesMap'],
        'fieldValueMap': value['fieldValueMap'],
        'fieldNames': value['fieldNames'] == null? value['fieldNames']: value['fieldNames'],
    };
}


